export const styles = {
  dateContainer: {
    width: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  dateText: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#8C8F9D',
    wordBreak: 'keep-all',
    whiteSpace: 'nowrap',
  },
  paperItem: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    columnGap: '20px',
    padding: '0px 20px',
  },

  contentContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    columnGap: '6px',
  },
  postContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    columnGap: '12px',
  },
  customAvatarContainer: { display: 'flex', width: '24px', height: '24px', position: 'relative' },
  avatarContainer: {
    display: 'flex',
    backgroundColor: '#EDEFF7',
    borderRadius: '4px',
    width: '24px',
    height: '24px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  avatar: {
    fontFamily: 'Inter',
    color: '#6E707A',
    fontSize: '12px',
    fontStyle: 'normal',
    lineHeight: '146%',
    fontWeight: '500',
    '-webkit-user-select': 'none',
    '-ms-user-select': 'none',
    'user-select': 'none',
  },
  imageGreenDot: {
    position: 'absolute',
    display: 'flex',
    width: '10px',
    height: '10px',
    backgroundColor: '#379552',
    border: '2px solid #FFFFFF',
    left: '-4px',
    top: '-4px',
    borderRadius: '50%',
    zIndex: '10',
  },
  badgeContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    rowGap: '20px',
    width: '100%',
    '& .infinite-scroll-component__outerdiv': {
      width: '98%',
      display: 'flex',
      '& .infinite-scroll-component': {
        '&::-webkit-scrollbar': {
          border: 'none',
          width: '11px',
          height: '11px',
          padding: '5px 0',
        },

        '&::-webkit-scrollbar-track': {
          backgroundColor: '#fff',
          border: 'none',
          height: '10px',
        },

        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#D4D6E0',
          width: '2px',
          borderRadius: '6px',
          cursor: 'pointer',
        },
      },
    },
  },
};
